/** @jsx jsx */
import { useEffect } from 'react';
import { css, jsx } from '@emotion/react'
import { graphql } from 'gatsby';
import { useLocalization } from "gatsby-theme-i18n";
import CrosssiteBannerSection from '../../sections/common/CrosssiteBannerSection';
import Seo from "../../components/SEO"
import PageHeadline from '../../components/PageHeadline';
import TimetableSection from '../../sections/program/TimetableSection';
import { Anchor } from "../../components/StyledComponents";

// import { DateTime } from 'luxon';

import PageNavigation from '../../components/PageNavigation'

const ProgramTimetablePage = ({ data }) => {

  const { t, addString, localeKey } = useLocalization();

  useEffect(() => {
    addString('program_timetable',data.allProgramTimetableCsv.nodes)
    addString('guest',data.allGuestCsv.nodes)
  },[addString,data]);
  
  return (
  <div css={css`background:#F7F7FA;`}>
    <Seo 
        title={data.pageTitle ? data.pageTitle[localeKey] : ''} 
        description={data.pageDescription ? data.pageDescription[localeKey] : ''}  />  
    <PageHeadline 
      category={t('program_timetable.page.category.label')} 
      title={t('program_timetable.page.display.title')} 
    />
    <PageNavigation list={[
        {
          id: 'day1',
          name:t('program_timetable.page.nav.day1'),
          //isNew:  DateTime.fromISO('2021-04-22T17:00:00+09:00').diff(DateTime.local(), [ 'days']).values.days > -3
        },
        {
          id: 'day2',
          name: t('program_timetable.page.nav.day2'),
          //isNew:  DateTime.fromISO('2021-04-22T17:00:00+09:00').diff(DateTime.local(), [ 'days']).values.days > -3
        }
    ]}/>
    <Anchor id="day1">{t('program_timetable.page.nav.day1')}</Anchor>
    <TimetableSection 
      list={data.day1List}
      defaultVisual={'special_live_piano'}
      position={'right'}
      id={'day1'} 
    />

    <Anchor id="day2">{t('program_timetable.page.nav.day2')}</Anchor>
    <TimetableSection 
      list={data.day2List}
      defaultVisual={'special_live_band'}
      position={'left'}
      id={'day2'} 
    />
    
    <CrosssiteBannerSection />
  </div>
);
}
 
export default ProgramTimetablePage;

export const query = graphql`
  query ProgramTimelinePageQuery {
    pageTitle : programTimetableCsv(key: {regex: "/^page.title/"}) {
      ...localizedContent
    }
    pageDescription : programTimetableCsv(key: {regex: "/^page.description/"}) {
      ...localizedContent
    }
    pageKeywords : programTimetableCsv(key: {regex: "/^page.keywords/"}) {
      ...localizedContent
    }

    allProgramTimetableCsv {
      nodes {
        ...localizedContent
      }
    }

    allGuestCsv {
      nodes {
        ...localizedContent
      }
    }

    day1List: allProgram(
      sort: {fields: data___start_time, order: ASC}
      filter: {data: {status: {eq: "publish"}, date: {eq: "1"}}}
    ) {
      edges {
        node {
          annotation {
            ...localizedContent
          }
          title {
            ...localizedContent
          }
          time {
            ...localizedContent
          }
          data {
            update_date
            type
            stream_url
            status
            start_time
            key
            end_time
            date
          }
          desc {
            ...localizedContent
          }
          thumb {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH, placeholder: NONE)
            }
          }
          visual {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH, placeholder: NONE)
            }
          }
          performers { ...localizedContent }
          guests {
            name { ...localizedContent }
            title { ...localizedContent }
            tooltip { ...localizedContent }
            image {
              childImageSharp {
                gatsbyImageData(
                  layout: FULL_WIDTH
                  placeholder: NONE
                )
              }
            }
            thumb {
              childImageSharp {
                gatsbyImageData(
                  layout: FULL_WIDTH
                  placeholder: NONE
                )
              }
            }
          }
        }
      }
    }

    day2List: allProgram(
      sort: {fields: data___start_time, order: ASC}
      filter: {data: {status: {eq: "publish"}, date: {eq: "2"}}}
    ) {
      edges {
        node {
          annotation {
            ...localizedContent
          }
          title {
            ...localizedContent
          }
          time {
            ...localizedContent
          }
          data {
            update_date
            type
            stream_url
            status
            start_time
            key
            end_time
            date
          }
          desc {
            ...localizedContent
          }
          thumb {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH, placeholder: NONE)
            }
          }
          visual {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH, placeholder: NONE)
            }
          }
          performers { ...localizedContent }
          guests {
            name { ...localizedContent }
            title { ...localizedContent }
            tooltip { ...localizedContent }
            image {
              childImageSharp {
                gatsbyImageData(
                  layout: FULL_WIDTH
                  placeholder: NONE
                )
              }
            }
            thumb {
              childImageSharp {
                gatsbyImageData(
                  layout: FULL_WIDTH
                  placeholder: NONE
                )
              }
            }
          }
        }
      }
    }

  }
`
